// React
import React from 'react';
import PropTypes from 'prop-types';
import Classnames from 'classnames';
// Style
import { withStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Facade from 'core/Facade';

// SIZE PROPS IS NEEDED //
/* eslint-disable react/no-string-refs */
class Dropzone extends React.PureComponent {

    static propTypes = {
        file: PropTypes.object,
        width: PropTypes.number.isRequired,
        setFile: PropTypes.func,
        uploadText: PropTypes.string,
        title: PropTypes.string,
        emptyText: PropTypes.string,
        error: PropTypes.bool,
        classes: PropTypes.object
    };

    state = {
        hightlight: false
    };

    onFilesAdded = (event) => {
        this.props.setFile(event.target.files[0]);
    };

    handleClick = () => this.refs.fileUploader.click();

    onDragOver = (event) => {
        event.preventDefault();
        this.setState({ hightlight: true });
    };

    onDragLeave = () => this.setState({ hightlight: false });

    onDrop = (event) => {
        event.preventDefault();
        this.setState({ hightlight: false });
        this.props.setFile(event.dataTransfer.files[0]);
    };

    onChange = (evt) => this.onFilesAdded(evt);

    getSize = () => {
        const { width } = this.props;
        const height = width / 2;

        return {
            width:  [width] + 'px',
            height: [height] +'px'
        };
    };

    render() {
        const { classes, uploadText, file, title, emptyText, error } = this.props;
        return (
            <div className={classes.root} style={error ? { borderColor:'red' } : null }>
                <div className={classes.cardHeader}>
                    {title}
                </div>
                <div className={classes.content} style={this.getSize()}>
                    <div
                        className={Classnames(classes.dropzone, this.state.hightlight && classes.highlight)}
                        onDragOver={this.onDragOver}
                        onDragLeave={this.onDragLeave}
                        onDrop={this.onDrop}
                        onClick={this.handleClick}
                        onChange={this.onChange}
                    >
                        <input
                            className={classes.fileInput}
                            type='file'
                            ref='fileUploader'
                            value= ''
                            onChange={this.onChange}
                        />
                        {Facade.isEmpty(file) ?
                            <div className={classes.dropzoneEmpty}>
                                <CloudUploadIcon className={classes.iconEmpty}/>
                                <Typography className={classes.uploadText} >{uploadText}</Typography>
                            </div>
                            :
                            <div>
                                <CloudUploadIcon className={classes.iconFilled} />

                            </div>
                        }
                    </div>
                    <div >
                        {!Facade.isEmpty(file) ?
                            <Typography className={classes.fileName} style={{ color: '#0F5663' }}>{file.name}</Typography>
                            :
                            <Typography className={classes.fileName}> {emptyText} </Typography>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

const styles = () => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        borderStyle: 'solid',
        borderWidth: '1px',
        borderRadius: '4px',
        borderColor: 'rgba(0, 0, 0, 0.23)',
    },

    cardHeader: {
        margin: '15px',
        fontSize: '1.4em',
    },

    content: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
    },

    dropzone: {
        cursor: 'pointer',
        margin: '20px',
        minHeight: '80%',
        minWidth: '40%',
        backgroundColor: '#fff',
        border: '2px dashed rgb(187, 186, 186)',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        fontSize: '16px',
    },

    dropzoneEmpty: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
    },

    uploadText: {
        marginTop: '-8px',
        fontSize: '1em'
    },

    iconEmpty: {
        fontSize: '80px',
        color: '#0F5663',
        opacity: '0.4'
    },

    iconFilled: {
        fontSize: '70px',
        color: '#0F5663',
        opacity: '1',
    },

    fileName: {
        marginLeft: '10px',
        fontSize: '1em',
    },

    highlight: {
        backgroundColor: '#b8d5cd',
    },

    fileInput: {
        display: 'none',
    }
});

export default withStyles(styles)(Dropzone);
